import { createActionGroup, emptyProps } from '@ngrx/store';

export const ArticleStatusActions = createActionGroup({
  source: 'Article Status',
  events: {
    'Reset reducer': emptyProps()
  }
});
